import { createContext } from "react";

export interface ApplicationContextType {
    user: any;
    setUser: (user: any) => void;
}

export const ApplicationContext = createContext<ApplicationContextType>({
    user: null,
    setUser: () => {},
});